export var HARMONY_THEME_USER_STORAGE_KEY = 'HarmonyTheme';
//# sourceMappingURL=harmonyThemeUserStorage.js.map